// Reads the `exp` claim (seconds since epoch) out of a JWT without verifying
// it -- purely to know when to proactively end the session on the client, so
// expiry surfaces as a clean return to the login screen rather than a failed
// request mid-action. Never trust this for anything security-relevant; the
// server is the only authority on token validity.
export function getTokenExpiryMs(token: string): number | null {
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;
    const json = JSON.parse(
      atob(payload.replace(/-/g, "+").replace(/_/g, "/")),
    ) as { exp?: unknown };
    return typeof json.exp === "number" ? json.exp * 1000 : null;
  } catch {
    return null;
  }
}
